import { FF_COMPARISON_EXPERIENCE } from '../constants'

// Feature flag for New Web pricing
export const getWebPricingFeatureFlag = () => window.flags && window.flags['GNA-11926-NEW-WEB-PRICING'];

// Feature flag for Hiding Logged out Pricing
export const hideLoggedOutPricingFF = () => window.flags && window.flags["GNA-12455-HIDE-LOGGEDOUT-PRICING-BY-SALESORG"];

// Feature flag for Short-Term Leasing Options on Web
export const shortTermLeasingOptionFF = () => window.flags && window.flags["GNA-16282-SHORT_TERM_LEASING_OPTION"];

// Feature flag for Comparison Experience - must be true by default (or when this FF does not exist) because this is
// an already existing feature but needs to be disabled temporarily for the Coveo Search MVP launch
export const comparisonExperienceFF = () => {
  if (typeof window === 'undefined') return true
  const value = window?.flags?.[FF_COMPARISON_EXPERIENCE]
  return value === undefined || value === null ? true : !!value
}
